// Action Types
export const FETCH_GROUPS_REQUEST = 'FETCH_GROUPS_REQUEST';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILURE = 'FETCH_GROUPS_FAILURE';
export const CREATE_GROUP_REQUEST = 'CREATE_GROUP_REQUEST';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILURE = 'CREATE_GROUP_FAILURE';

// Action Creators
export const fetchGroupsRequest = () => ({ type: FETCH_GROUPS_REQUEST });
export const fetchGroupsSuccess = (data) => ({ type: FETCH_GROUPS_SUCCESS, payload: data });
export const fetchGroupsFailure = (error) => ({ type: FETCH_GROUPS_FAILURE, payload: error });
export const createGroupRequest = (data) => ({ type: CREATE_GROUP_REQUEST, payload: data });
export const createGroupSuccess = (data) => ({ type: CREATE_GROUP_SUCCESS, payload: data });
export const createGroupFailure = (error) => ({ type: CREATE_GROUP_FAILURE, payload: error });
